export const profileData = {
  name: "佐佐木明希",
  nameEn: "Aki Sasaki",
  nameJa: "佐々木 明希",
  birthday: "1992年3月15日",
  birthplace: "日本东京都",
  height: "162cm",
  bloodType: "A型",
  hobby: "旅行、摄影、阅读、瑜伽",
  specialty: "钢琴、书法、日本舞踊",
  debut: "2014年",
  agency: "Stardust Promotion",
  bio: "佐佐木明希，1992年出生于日本东京都，自幼展现出非凡的艺术天赋。2014年正式出道后，凭借清新自然的气质与扎实的表演功底迅速获得业界认可。多年来，她在影视、综艺、舞台剧等多个领域全面发展，以其温暖治愈的笑容和真诚的性格深受粉丝喜爱。除了演艺事业，佐佐木明希还积极投身公益事业，担任多个儿童教育基金的宣传大使。",
  socialLinks: {
    twitter: "https://twitter.com/sasakinoaki",
    instagram: "https://instagram.com/sasakinoaki",
    youtube: "https://youtube.com/@sasakinoaki",
    weibo: "https://weibo.com/sasakinoaki",
  },
  achievements: [
    "第45届日本电影学院奖 最佳新人奖",
    "2023年东京国际电影节 最受欢迎女演员",
    "第60届银河奖 年度个人奖",
    "日本放送协会 NHK 红白歌会 特别嘉宾（2024）",
    "联合国儿童基金会 日本亲善大使（2025年任命）",
  ],
};